var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAuFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 18,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#au-flag_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M0 0h24v18H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M0 0h12v9H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m1.406 0 4.575 3.394L10.538 0H12v1.163L7.5 4.518 12 7.856V9h-1.5L6 5.644 1.519 9H0V7.875l4.481-3.338L0 1.2V0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M7.95 5.269 12 8.25V9L6.919 5.269zm-3.45.375.112.656-3.6 2.7H0zM12 0v.056L7.331 3.581l.038-.825L11.063 0zM0 0l4.481 3.3H3.356L0 .788z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.519 0v9h3V0zM0 3v3h12V3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M0 3.619v1.8h12v-1.8zM5.119 0v9h1.8V0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m6 10.6.609 1.435 1.502-.418-.742 1.371 1.263.913-1.534.274.073 1.558L6 14.704l-1.171 1.029.073-1.558-1.534-.274 1.263-.913-.742-1.371 1.502.418zM18 4.95l.327.771.807-.225-.399.736.679.491-.824.147.039.836L18 7.154l-.629.552.039-.836-.824-.147.679-.491-.399-.736.807.225zM14.9 8.95l.327.771.807-.225-.399.736.679.491-.824.147.039.836-.629-.552-.629.552.039-.836-.824-.147.679-.491-.399-.736.807.225zM21.3 7.55l.327.771.807-.225-.399.736.679.491-.824.147.039.836-.629-.552-.629.552.039-.836-.824-.147.679-.491-.399-.736.807.225zM18.2 13.75l.327.771.807-.225-.399.736.679.491-.824.147.039.836-.629-.552-.629.552.039-.836-.824-.147.679-.491-.399-.736.807.225zM19.9 11.3l.235.476.526.077-.381.371.09.523-.47-.247-.47.247.09-.523-.381-.371.526-.077z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "au-flag_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 18,
  fill: "#fff",
  rx: 3
})))));
export { SvgAuFlag as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNTMwNWZlYmY2ZmEyNzBmODE4MTZjMWU1MGYwMzUwZjguc3ZnIjs=";